import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'antd-mobile';
import { sendSms, liveSendMsg } from '../../service/chat-service';

import styles from './styles.module.less';

const propTypes = {
  phoneNumber: PropTypes.string,
  countdownTime: PropTypes.number, // 倒计时时间 秒为单位
  countdownUnit: PropTypes.number, // 倒计时步长值 单位为毫秒
  className: PropTypes.string,
  type: PropTypes.string,
};

const defaultProps = {
  countdownTime: 60,
  countdownUnit: 1000,
  type: '1',
  phoneNumber: '',
  className: '',
};

/**
 * 发送验证码
 */
class SendVRCode extends Component {
  timer = null;

  constructor(props) {
    super(props);
    const { countdownTime } = this.props;
    this.state = {
      countdown: countdownTime,
    };
  }

  handleCountDown = async () => {
    const {
      countdownTime, countdownUnit, phoneNumber, type,
    } = this.props;
    const { countdown } = this.state;
    const serve = type === 'live' ? liveSendMsg : sendSms;

    if (!phoneNumber || (phoneNumber && phoneNumber.length < 11)) return Toast.show('请检查手机号输入');
    if (countdown !== countdownTime) return false;

    this.setState({ countdown: countdown - countdownUnit / 1000 });

    try {
      const data = type === 'live' ? { type, mobile: phoneNumber } : `?type=${type}&mobile=${phoneNumber}`;
      const { code, message } = await serve(data);

      if (code !== 10000) {
        throw message;
      }

      this.timer = setInterval(() => {
        const { countdown: cd } = this.state;
        const newCountdown = cd - countdownUnit / 1000;

        if (newCountdown <= 0) {
          this.setState({ countdown: countdownTime });
          clearInterval(this.timer);
        } else {
          this.setState({ countdown: newCountdown });
        }
      }, countdownUnit);
    } catch (e) {
      clearInterval(this.timer);
      this.setState({ countdown: countdownTime });
      Toast.show(e.message || e || '发送验证码失败');
    }
    return true;
  };

  render() {
    const { className } = this.props;
    const { countdown } = this.state;
    const style = className || styles.PINCode;

    return (
      <>
        {
          countdown === 60
            ? <span onClick={this.handleCountDown} className={style} role="button" tabIndex={0}>发送验证码</span>
            : <span className={style}>{`${countdown}秒`}</span>
        }
      </>
    );
  }
}

SendVRCode.propTypes = propTypes;
SendVRCode.defaultProps = defaultProps;

export default SendVRCode;
